import React from "react";
import { Space } from "antd";
import { AxSelect, AxIconWrapper, AxDivider, AxButton } from "@dynata/axiom3";
const { Option } = AxSelect;
class Select extends React.Component {
  render() {
    return (
      <div className="section input" id="select">
        <h3>Select</h3>
        <p>Select component to select value from options.</p>
        <AxDivider orientation="left" plain>
          Basic Usage{" "}
        </AxDivider>
        <Space direction="vertical" size="large">
          <pre>{`
<AxSelect
  style={{ width: 200 }}
  size="small"
  placeholder="Select Item"
  label="Select Label"
  caption="Select caption"
>
  <Option value="one">One</Option>
  <Option value="two">Two</Option>
  <Option value="three">Three</Option>
  <Option value="four">Four</Option>
  <Option value="five">Five</Option>
  <Option value="disabled" disabled>
    Disabled
  </Option>
</AxSelect>
`}</pre>
          <div className="prop-header">
            <p className="props-title">Props</p>
            <p>
              For AntD props, visit{" "}
              <AxButton
                size="small"
                type="link"
                target="_blank"
                href="https://ant.design/components/select/#API"
              >
                https://ant.design/components/select/#API
              </AxButton>
            </p>
          </div>
          <table className="props-table">
            <thead>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Type</th>
                <th>Default</th>
                <th>Version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>size</td>
                <td>Select size</td>
                <td>small | medium | large</td>
                <td>medium</td>
                <td></td>
              </tr>
              <tr>
                <td>type</td>
                <td>Predefined types</td>
                <td>danger | positive | warning</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>direction</td>
                <td>Default is, vertical</td>
                <td>horizontal | vertical</td>

                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>label</td>
                <td>Same as HTML attribute</td>
                <td>string</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>caption</td>
                <td>Display caption text</td>
                <td>string</td>

                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>allowClear</td>
                <td>Show clear button</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>autoClearSearchValue</td>
                <td>
                  Whether the current search will be cleared on selecting an
                  item. Only applies when <code>mode</code> is set to{" "}
                  <code>multiple</code> or <code>tags</code>
                </td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>autoFocus</td>
                <td>Get focus by default</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>bordered</td>
                <td>Whether has border style</td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>clearIcon</td>
                <td>The custom clear icon</td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>defaultActiveFirstOption</td>
                <td>Whether active first option by default</td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>defaultOpen</td>
                <td>Initial open state of dropdown</td>
                <td>boolean</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>defaultValue</td>
                <td>Initial selected option</td>
                <td>
                  <pre>{`string | string[]<br>
        number | number[]<br>
        LabeledValue | LabeledValue[]`}</pre>{" "}
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>disabled</td>
                <td>Whether disabled select</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>popupClassName</td>
                <td>The className of dropdown menu</td>
                <td>string</td>
                <td>-</td>
                <td>4.23.0</td>
              </tr>
              <tr>
                <td>dropdownMatchSelectWidth</td>
                <td>
                  Determine whether the dropdown menu and the select input are
                  the same width. Default set <code>min-width</code> same as
                  input. Will ignore when value less than select width.{" "}
                  <code>false</code> will disable virtual scroll
                </td>
                <td>boolean | number</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>dropdownRender</td>
                <td>Customize dropdown content</td>
                <td>(originNode: ReactNode) =&gt; ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>dropdownStyle</td>
                <td>The style of dropdown menu</td>
                <td>CSSProperties</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>fieldNames</td>
                <td>Customize node label, value, options field name</td>
                <td>object</td>
                <td>
                  <pre>{`{ label: <code>label</code>, value: <code>value</code>, options: <code>options</code> }`}</pre>
                </td>
                <td>4.17.0</td>
              </tr>
              <tr>
                <td>filterOption</td>
                <td>
                  If true, filter options by input, if function, filter options
                  against it. The function will receive two arguments,{" "}
                  <code>inputValue</code> and <code>option</code>, if the
                  function returns <code>true</code>, the option will be
                  included in the filtered set; Otherwise, it will be excluded
                </td>
                <td>boolean | function(inputValue, option)</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>filterSort</td>
                <td>
                  Sort function for search options sorting, see{" "}
                  <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort">
                    Array.sort
                  </a>
                  's compareFunction
                </td>
                <td>(optionA: Option, optionB: Option) =&gt; number</td>
                <td>-</td>
                <td>4.9.0</td>
              </tr>
              <tr>
                <td>getPopupContainer</td>
                <td>
                  Parent Node which the selector should be rendered to. Default
                  to <code>body</code>. When position issues happen, try to
                  modify it into scrollable content and position it relative.{" "}
                  <a href="https://codesandbox.io/s/4j168r7jw0">Example</a>
                </td>
                <td>function(triggerNode)</td>
                <td>() =&gt; document.body</td>
                <td></td>
              </tr>
              <tr>
                <td>labelInValue</td>
                <td>
                  Whether to embed label in value, turn the format of value from{" "}
                  <code>string</code> to{" "}
                  <pre>{`{ value: string, label: ReactNode }`}</pre>
                </td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>listHeight</td>
                <td>Config popup height</td>
                <td>number</td>
                <td>256</td>
                <td></td>
              </tr>
              <tr>
                <td>loading</td>
                <td>Indicate loading state</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>maxTagCount</td>
                <td>
                  Max tag count to show. <code>responsive</code> will cost
                  render performance
                </td>
                <td>
                  number | <code>responsive</code>
                </td>
                <td>-</td>
                <td>responsive: 4.10</td>
              </tr>
              <tr>
                <td>maxTagPlaceholder</td>
                <td>Placeholder for not showing tags</td>
                <td>ReactNode | function(omittedValues)</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>maxTagTextLength</td>
                <td>Max tag text length to show</td>
                <td>number</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>menuItemSelectedIcon</td>
                <td>The custom menuItemSelected icon with multiple options</td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>mode</td>
                <td>Set mode of Select</td>
                <td>
                  <code>multiple</code> | <code>tags</code>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>notFoundContent</td>
                <td>Specify content to show when no result matches</td>
                <td>ReactNode</td>
                <td>
                  <code>Not Found</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>open</td>
                <td>Controlled open state of dropdown</td>
                <td>boolean</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>optionFilterProp</td>
                <td>
                  Which prop value of option will be used for filter if
                  filterOption is true. If <code>options</code> is set, it
                  should be set to <code>label</code>
                </td>
                <td>string</td>
                <td>
                  <code>value</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>optionLabelProp</td>
                <td>
                  Which prop value of option will render as content of select.{" "}
                  <a href="https://codesandbox.io/s/antd-reproduction-template-tk678">
                    Example
                  </a>
                </td>
                <td>string</td>
                <td>
                  <code>children</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>options</td>
                <td>
                  Select options. Will get better perf than jsx definition
                </td>
                <td>
                  <pre>{`{(label, value)}[]`}</pre>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>placeholder</td>
                <td>Placeholder of select</td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>placement</td>
                <td>The position where the selection box pops up</td>
                <td>
                  <code>bottomLeft</code> <code>bottomRight</code>{" "}
                  <code>topLeft</code> <code>topRight</code>
                </td>
                <td>bottomLeft</td>
                <td></td>
              </tr>
              <tr>
                <td>removeIcon</td>
                <td>The custom remove icon</td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>searchValue</td>
                <td>The current input "search" text</td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>showArrow</td>
                <td>Whether to show the drop-down arrow</td>
                <td>boolean</td>
                <td>true(for single select), false(for multiple select)</td>
                <td></td>
              </tr>
              <tr>
                <td>showSearch</td>
                <td>Whether select is searchable</td>
                <td>boolean</td>
                <td>single: false, multple: true</td>
                <td></td>
              </tr>
              <tr>
                <td>size</td>
                <td>Size of Select input</td>
                <td>
                  <code>large</code> | <code>middle</code> | <code>small</code>
                </td>
                <td>
                  <code>middle</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>status</td>
                <td>Set validation status</td>
                <td>'error' | 'warning'</td>
                <td>-</td>
                <td>4.19.0</td>
              </tr>
              <tr>
                <td>suffixIcon</td>
                <td>The custom suffix icon</td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>tagRender</td>
                <td>
                  Customize tag render, only applies when <code>mode</code> is
                  set to <code>multiple</code> or <code>tags</code>
                </td>
                <td>(props) =&gt; ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>tokenSeparators</td>
                <td>
                  Separator used to tokenize, only applies when{" "}
                  <code>mode="tags"</code>
                </td>
                <td>string[]</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>value</td>
                <td>
                  Current selected option (considered as a immutable array)
                </td>
                <td>
                  <pre>{`string | string[]<br>
        number | number[]<br>
        LabeledValue | LabeledValue[]`}</pre>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>virtual</td>
                <td>Disable virtual scroll when set to false</td>
                <td>boolean</td>
                <td>true</td>
                <td>4.1.0</td>
              </tr>
              <tr>
                <td>onBlur</td>
                <td>Called when blur</td>
                <td>function</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onChange</td>
                <td>Called when select an option or input value change</td>
                <td>function(value, option:Option | Array&lt;Option&gt;)</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onClear</td>
                <td>Called when clear</td>
                <td>function</td>
                <td>-</td>
                <td>4.6.0</td>
              </tr>
              <tr>
                <td>onDeselect</td>
                <td>
                  Called when an option is deselected, param is the selected
                  option's value. Only called for <code>multiple</code> or{" "}
                  <code>tags</code>, effective in multiple or tags mode only
                </td>
                <td>function(string | number | LabeledValue)</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onDropdownVisibleChange</td>
                <td>Called when dropdown open</td>
                <td>function(open)</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onFocus</td>
                <td>Called when focus</td>
                <td>function</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onInputKeyDown</td>
                <td>Called when key pressed</td>
                <td>function</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onMouseEnter</td>
                <td>Called when mouse enter</td>
                <td>function</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onMouseLeave</td>
                <td>Called when mouse leave</td>
                <td>function</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onPopupScroll</td>
                <td>Called when dropdown scrolls</td>
                <td>function</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onSearch</td>
                <td>Callback function that is fired when input changed</td>
                <td>function(value: string)</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onSelect</td>
                <td>
                  Called when an option is selected, the params are option's
                  value (or key) and option instance
                </td>
                <td>
                  function(string | number | LabeledValue, option: Option)
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>className</td>
                <td>The additional class to option</td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>disabled</td>
                <td>Disable this option</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>title</td>
                <td>
                  <code>title</code> attribute of Select Option
                </td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>value</td>
                <td>Default to filter with this property</td>
                <td>string | number</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>key</td>
                <td>Group key</td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>label</td>
                <td>Group label</td>
                <td>string | React.Element</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>...others</td>
                <td>
                  All extra props are passed down to the{" "}
                  <>
                    <AxButton
                      size="small"
                      type="link"
                      target="_blank"
                      href="https://4x.ant.design/components/select/#API"
                    >
                      {`<Select />`}
                    </AxButton>
                  </>{" "}
                  component.
                </td>
                <td></td>
                <td>-</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </Space>

        <AxDivider orientation="left" plain>
          Size
        </AxDivider>
        <pre>{`
<AxSelect
  style={{ width: 200 }}
  size="small"
  placeholder="Select Item"
>
  <Option value="one">One</Option>
  <Option value="two">Two</Option>
  <Option value="three">Three</Option>
  <Option value="four">Four</Option>
  <Option value="five">Five</Option>
  <Option value="disabled" disabled>
    Disabled
  </Option>
</AxSelect>
`}</pre>
        <Space size="large">
          <AxSelect
            style={{ width: 200 }}
            size="small"
            placeholder="Select Item"
          >
            <Option value="one">One</Option>
            <Option value="two">Two</Option>
            <Option value="three">Three</Option>
            <Option value="four">Four</Option>
            <Option value="five">Five</Option>
            <Option value="disabled" disabled>
              Disabled
            </Option>
          </AxSelect>

          <AxSelect
            style={{ width: 200 }}
            size="medium"
            placeholder="Select Item"
          >
            <Option value="one">One</Option>
            <Option value="two">Two</Option>
            <Option value="three">Three</Option>
            <Option value="four">Four</Option>
            <Option value="five">Five</Option>
            <Option value="disabled" disabled>
              Disabled
            </Option>
          </AxSelect>

          <AxSelect
            style={{ width: 200 }}
            size="large"
            placeholder="Select Item"
          >
            <Option value="one">One</Option>
            <Option value="two">Two</Option>
            <Option value="three">Three</Option>
            <Option value="four">Four</Option>
            <Option value="five">Five</Option>
            <Option value="disabled" disabled>
              Disabled
            </Option>
          </AxSelect>
        </Space>

        <AxDivider orientation="left" plain>
          Flags
        </AxDivider>
        <pre>{`
<AxSelect
style={{ width: 200 }}
placeholder={
  <span>
    <AxIconWrapper
      type="regular"
      size="12"
      icon={"fa-location-pin"}
    />{" "}
    Location
  </span>
}
>
<Option value="US">
  <AxFlag
    country="US"
    svgProps={{ width: 24, viewBox: "0 0 25 16" }}
  />
  United States
</Option>
<Option value="AR">
  <AxFlag
    country="AR"
    svgProps={{ width: 24, viewBox: "0 0 25 16" }}
  />
  Argentina
</Option>
<Option value="BR">
  <AxFlag
    country="BR"
    svgProps={{ width: 24, viewBox: "0 0 25 16" }}
  />
  Brazil
</Option>
<Option value="CA">
  <AxFlag
    country="CA"
    svgProps={{ width: 24, viewBox: "0 0 25 16" }}
  />
  Canada
</Option>
<Option value="CO">
  <AxFlag
    country="CO"
    svgProps={{ width: 24, viewBox: "0 0 25 16" }}
  />
  Colombia
</Option>
<Option value="FR">
  <AxFlag
    country="FR"
    svgProps={{ width: 24, viewBox: "0 0 25 16" }}
  />
  France
</Option>
</AxSelect>
`}</pre>
        <Space size="large">
          {/* <AxSelect
            style={{ width: 200 }}
            placeholder={
              <span>
                <AxIconWrapper
                  type="regular"
                  size="12"
                  icon={"fa-location-pin"}
                />{" "}
                Location
              </span>
            }
          >
            <Option value="US">
              <AxFlag
                country="US"
                svgProps={{ width: 24, viewBox: "0 0 25 16" }}
              />
              United States
            </Option>
            <Option value="AR">
              <AxFlag
                country="AR"
                svgProps={{ width: 24, viewBox: "0 0 25 16" }}
              />
              Argentina
            </Option>
            <Option value="BR">
              <AxFlag
                country="BR"
                svgProps={{ width: 24, viewBox: "0 0 25 16" }}
              />
              Brazil
            </Option>
            <Option value="CA">
              <AxFlag
                country="CA"
                svgProps={{ width: 24, viewBox: "0 0 25 16" }}
              />
              Canada
            </Option>
            <Option value="CO">
              <AxFlag
                country="CO"
                svgProps={{ width: 24, viewBox: "0 0 25 16" }}
              />
              Colombia
            </Option>
            <Option value="FR">
              <AxFlag
                country="FR"
                svgProps={{ width: 24, viewBox: "0 0 25 16" }}
              />
              France
            </Option>
          </AxSelect> */}

          <AxSelect
            style={{ width: 200 }}
            placeholder={
              <span>
                <AxIconWrapper
                  type="regular"
                  size="12"
                  icon={"fa-location-pin"}
                />{" "}
                Location
              </span>
            }
          >
            <Option value="US">United States</Option>
            <Option value="AR">Argentina</Option>
            <Option value="BR">Brazil</Option>
            <Option value="CA">Canada</Option>
            <Option value="CO">Colombia</Option>
            <Option value="FR">France</Option>
          </AxSelect>
        </Space>
      </div>
    );
  }
}
export default Select;
